export default {"src":"/_next/static/media/key.4409c20e.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};